import { safeFetch } from "../utils/safeFetch";

async function parseError(response, fallback) {
  const error = await response.json().catch(() => ({}));
  return new Error(error.error || fallback || `HTTP error! status: ${response.status}`);
}

export async function getAllUsageTypes(token, tenant) {
  const response = await safeFetch(`/api/usage-types`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });
  if (!response.ok) throw await parseError(response, "Errore nel recupero tipi di utilizzo");
  return response.json();
}

export async function createUsageType(payload, token, tenant) {
  const response = await safeFetch(`/api/usage-types`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw await parseError(response, "Errore creazione tipo di utilizzo");
  return response.json();
}

export async function updateUsageType(id, payload, token, tenant) {
  const response = await safeFetch(`/api/usage-types/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw await parseError(response, "Errore aggiornamento tipo di utilizzo");
  return response.json();
}

export async function deleteUsageType(id, token, tenant) {
  const response = await safeFetch(`/api/usage-types/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });
  if (!response.ok) throw await parseError(response, "Errore eliminazione tipo di utilizzo");
}
